/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import GridButton from "../../../../components/Tablet/GridButton"
import { useHistory } from "react-router-dom"
import { TenkoDetailContext } from "../../context/context"
import ZyomuinInfo from "../../../../components/Tablet/ZyomuinInfo"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes, faWrench } from "@fortawesome/free-solid-svg-icons"
import { selectMenkyoUmuPage } from "../../../../constant/tablet/pages"

const SelectNitizyoTenken = () => {
  const history = useHistory()

  const { 点呼明細, set点呼明細 } = useContext(TenkoDetailContext)

  const select日常点検 = (日常点検フラグ: 0 | 1) => () => {
    set点呼明細({
      ...点呼明細,
      日常点検フラグ: 日常点検フラグ,
    })
    history.push(selectMenkyoUmuPage.Route.path)
  }

  return (
    <>
      <ZyomuinInfo />
      <table
        style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }}
        className="w-100 mt-3">
        <tbody>
          <tr>
            <td colSpan={2}>点検を実施しましたか？</td>
          </tr>
          <tr>
            <td>
              <GridButton onTouchStartEventHandler={select日常点検(1)}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <FontAwesomeIcon
                    style={{ marginRight: "2rem", color: "#0074be" }}
                    icon={faWrench}
                  />
                  <span>OK</span>
                </div>
              </GridButton>
            </td>
            <td>
              <GridButton onTouchStartEventHandler={select日常点検(0)}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <div
                    className="d-inline-block"
                    style={{ position: "relative" }}>
                    <FontAwesomeIcon
                      style={{ marginRight: "2rem" }}
                      icon={faWrench}
                    />
                    <FontAwesomeIcon
                      style={{
                        color: CSS_PROPERTY.WARN_COLOR,
                        fontSize: "4rem",
                        position: "absolute",
                        top: "-1rem",
                        left: "-1rem",
                      }}
                      icon={faTimes}
                    />
                  </div>
                  <span>未実施</span>
                </div>
              </GridButton>
            </td>
          </tr>
          <tr>
            <td
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              {/* 始業・始業2でここに来た場合、登録後の関係上、前のページに戻るのは不都合があるためボタンを表示しない */}
              {/* <BackButton /> */}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default SelectNitizyoTenken
